<lvr-field [label]="placeholder() | transloco">
	<mat-form-field lvrInput [class.is-disabled]="isDisabled()">
		<input
			#taskSearchInput
			#taskTrigger="matAutocompleteTrigger"
			matInput
			autocomplete="off"
			[placeholder]="searchPlaceholder() | transloco"
			[disabled]="isDisabled() || isLoading()"
			[value]="displayText()"
			(focus)="onFocus(); taskTrigger.openPanel()"
			(input)="onSearch($event); taskTrigger.openPanel()"
			(blur)="onBlur()"
			[matAutocomplete]="taskAutocomplete"
		/>
		@if (focused() && filterText()) {
			<button
				mat-icon-button
				matSuffix
				type="button"
				aria-label="Suche löschen"
				(mousedown)="$event.preventDefault()"
				(click)="clearSearch()"
			>
				<mat-icon aria-hidden="true">close</mat-icon>
			</button>
		}
	</mat-form-field>
</lvr-field>

<mat-autocomplete
	#taskAutocomplete="matAutocomplete"
	[autoActiveFirstOption]="false"
	[hideSingleSelectionIndicator]="true"
	[displayWith]="displayWithTask"
	(optionSelected)="onOptionSelected($event.option.value, taskSearchInput)"
>
	@if (isLoading()) {
		<mat-option disabled>{{ 'tasks_picker.loading' | transloco }}</mat-option>
	} @else if (errorMessage()) {
		<mat-option disabled>{{ errorMessage() | transloco }}</mat-option>
	} @else {
		@for (task of filteredTasks(); track task.id) {
			<mat-option [value]="task" (mousedown)="$event.preventDefault()">
				<div class="task-option-content">
					<mat-checkbox [checked]="isSelected(task.id)"></mat-checkbox>
					<span class="task-description">
						{{ task.description }}
						@if (task.initial) {
							<span class="task-initial">({{ task.initial }})</span>
						}
					</span>
					@if (task.helpText) {
						<lvr-info-tooltip
							class="info-btn"
							[text]="task.helpText"
							[ariaLabel]="'Aufgabe ' + task.description + ' Info'"
						/>
					}
				</div>
			</mat-option>
		} @empty {
			<mat-option disabled>{{ noResultsText() | transloco }}</mat-option>
		}
	}
</mat-autocomplete>

@if (!focused() && selectedTasks().length > 0) {
	<ul class="selected-tasks">
		@for (task of selectedTasks(); track task.id) {
			<li>
				<mat-checkbox [checked]="true" (change)="toggleTask(task)">{{ task.description }}</mat-checkbox>
			</li>
		}
	</ul>
}
